import React from 'react';
import { motion } from 'framer-motion';
import { CJMSClient } from '../api/cjmsApi';
import { IntelligencePanel } from './IntelligencePanel';

interface ActionPanelProps {
    client: CJMSClient;
    onFetchScript?: (email: string) => Promise<string>;
    onSendWhatsApp?: (email: string, message: string) => Promise<void>;
}

// ActionPanel now renders the shared Intelligence Hub. The hub also has its
// own dedicated "Intelligence" tab inside ClientDetailView; this keeps the
// detail view's action rail populated without duplicating logic.
export const ActionPanel: React.FC<ActionPanelProps> = ({ client }) => {
    return (
        <motion.div
            key={client.id}
            initial={{ opacity: 0, y: 8 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.25 }}
        >
            <IntelligencePanel client={client} />
        </motion.div>
    );
};
